// ** MUI Imports
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import InputBase from '@mui/material/InputBase'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Avatar from '@mui/material/Avatar'
import Badge from '@mui/material/Badge'
import { useSelector } from 'react-redux'

// ** Icons Imports
import MenuIcon from 'mdi-material-ui/Menu'
import Magnify from 'mdi-material-ui/Magnify'
import BellOutline from 'mdi-material-ui/BellOutline'
import { usePageTitle } from 'src/context/PageTitleContext'
import beemzRound from "src/assets/images/beemz-round.png"

// ** Components
// import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'

const AppBarContent = props => {
  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility } = props

  const { title } = usePageTitle();
  const user = useSelector(state => state.auth.user);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: { xs: 1, sm: 2 },
        py: 2,
        px: { xs: 1.5, sm: 3 }
      }}
    >
      {/* Left: Hamburger (mobile/tablet) + Title */}
      <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, flexShrink: 1 }}>
        {hidden && (
          <IconButton
            color='inherit'
            onClick={toggleNavVisibility}
            sx={{ ml: -1, mr: 1 }}
            aria-label='open navigation menu'
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography
          variant='h6'
          noWrap
          sx={{
            fontWeight: 700,
            textTransform: 'none',
            letterSpacing: 0,
            mr: { xs: 0, sm: 4 },
            fontSize: { xs: 16, sm: 20 }
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Center: Search (hidden on extra-small screens) */}
      <Paper
        component='form'
        elevation={0}
        sx={{
          p: '2px 8px',
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          width: 260,
          backgroundColor: '#FAFAFC',
          boxShadow: 'none',
          borderRadius: 2,
          mr: 2
        }}
      >
        <Magnify sx={{ color: 'text.primary', mr: 1 }} />
        <InputBase
          sx={{ ml: 1, flex: 1, fontSize: 16 }}
          placeholder='search'
          inputProps={{ 'aria-label': 'search' }}
        />
      </Paper>

      {/* Right: Notification + User */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 2 }, flexShrink: 0 }}>
        <Badge
          variant='dot'
          color='secondary'
          overlap='circular'
          sx={{ mr: { xs: 0, sm: 2 } }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <IconButton aria-label='notifications'>
            <BellOutline />
          </IconButton>
        </Badge>
        {/* User section */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            alt='finance admin'
            src={beemzRound}
            sx={{ width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 }, mr: { xs: 0, sm: 1.5 } }}
          />
          <Box sx={{ display: { xs: 'none', sm: 'block' }, minWidth: 0 }}>
            <Typography noWrap sx={{ fontWeight: 700, fontSize: 16, lineHeight: 1 }}>
              {user?.name || 'finance admin'}
            </Typography>
            <Typography noWrap sx={{ fontSize: 13, color: 'text.secondary', lineHeight: 1 }}>
              {user?.email || 'admin@beemz.com'}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AppBarContent